import {http} from "@/config/HttpClient";
import {Alert} from "@/addons/Alert";
import {recaudacionStore} from "@/store/recaudacionStore";
import {AxiosResponse} from "axios";

export class ReporteCajeroBancoService {
    private static instance: ReporteCajeroBancoService;
    public static getInstance() {
        return this.instance || (this.instance = new this());
    }

    recaudacionStore = recaudacionStore();

    public async reporteCajeroBanco(data: any) {
        this.recaudacionStore.loading = true;
        try {
            const response = await http.get("reporteCajeroBanco", {params: data}).toPromise() as AxiosResponse;
            
            if (response && response.data.success) {
                this.recaudacionStore.facturasCajero = response.data.datos;
                this.recaudacionStore.cantidadFacturas = response.data.cantidadFacturas;
                this.recaudacionStore.totalRecaudado = response.data.totalRecaudado;
                this.recaudacionStore.detalleCajero = response.data.detalleCajero;
                this.recaudacionStore.fechaLiteral = response.data.fechaLiteral;
            } else if (response?.data?.message) {
                Alert.error(response.data.message);
            } else {
                Alert.error('Error al obtener el reporte');
            }
            this.recaudacionStore.loading = false;
        } catch (error: any) {
            const errorMsg = error?.response?.data?.message || error?.message || 'Error desconocido';
            Alert.error(errorMsg);
            this.recaudacionStore.loading = false;
        }
    }

    public async descargarReporteBancaMovil(data: any) {
        try {
            // Pasar los datos ya cargados en el store al backend
            // Order for CSV: Cuenta, Número de Factura, Factura (nfac), Fecha, CI/NIT, Razón Social, Total, Cajero
            const datosParaExcel = this.recaudacionStore.facturasCajero.map((f: any) => [
                f.cuenta || '',
                f.numero_factura || '',
                f.nfac || '',
                f.fecha || '',
                f.ci_nit || '',
                f.razon_social || '',
                f.total || '',
                f.cajero?.nombre || f.cajero?.ventanilla || ''
            ]);

            const requestData = {
                datos: datosParaExcel,
                cajero: this.recaudacionStore.detalleCajero,
                fecha: data.fechaInicial,
                format: 'xlsx'
            };

            const response = await http.post("descargarReporteBancaMovil", requestData, {responseType: 'blob'} as any).toPromise() as AxiosResponse;

            // Debug info: headers and blob size
            console.log('descargarReporteBancaMovil headers=', response.headers);
            console.log('descargarReporteBancaMovil blob size=', response?.data?.size);

            if (response && response.data && response.data.size > 0) {
                const contentType = response.headers?.['content-type'] || response.headers?.['Content-Type'] || 'application/octet-stream';
                const blob = new Blob([response.data], { type: contentType });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                // Use report date (fechaInicial) sent in requestData instead of current date
                const fecha = (requestData && requestData.fecha) ? requestData.fecha : new Date().toISOString().split('T')[0];
                const nombreCajero = String(this.recaudacionStore.detalleCajero || 'Cajero').replace(/[^a-zA-Z0-9_-]/g, '');
                // Determine extension: prefer XLSX when backend sent spreadsheet or when requested format is xlsx
                const extension = (contentType.includes('spreadsheet') || contentType.includes('excel') || requestData.format === 'xlsx') ? 'xlsx' : 'csv';
                link.href = url;
                link.setAttribute('download', `Reporte_${nombreCajero}_${fecha}.${extension}`);
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);
                window.URL.revokeObjectURL(url);
                //Alert.info('Reporte descargado exitosamente');
            } else {
                // Try to read server message from the blob (maybe backend returned JSON error)
                try {
                    const blob = response?.data;
                    let text = '';
                    if (blob && typeof blob.text === 'function') {
                        text = await blob.text();
                    }
                    console.warn('descargarReporteBancaMovil empty blob, server text=', text);
                    try {
                        const parsed = JSON.parse(text || '{}');
                        if (parsed && parsed.message) {
                            Alert.error(parsed.message);
                            return;
                        }
                    } catch (e) {
                        // not JSON
                    }
                    if (text) {
                        Alert.error(text);
                    } else {
                        Alert.error('El reporte está vacío');
                    }
                } catch (e) {
                    console.error('Error leyendo blob vacío', e);
                    Alert.error('El reporte está vacío');
                }
            }
        } catch (error: any) {
            console.error('Error descargando reporte:', error);
            let errorMsg = 'Error al descargar el reporte';
            try {
                if (error?.response?.data?.message) {
                    errorMsg = error.response.data.message;
                } else if (error?.message) {
                    errorMsg = error.message;
                } else if (typeof error === 'string') {
                    errorMsg = error;
                }
            } catch (e) {
                console.error('Error parsing error:', e);
            }
            Alert.error(errorMsg);
        }
    }

    public async getHistorial(cobranzaId: number) {
        const data = {cobranzaId: cobranzaId}
        await http.get("historiales", {params: data}).subscribe({
            next: (response: AxiosResponse) => {
                this.recaudacionStore.historiales = response.data;
            }
        })
    }
}
